import script from "./ckEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ckEditor.vue?vue&type=script&setup=true&lang=js"

import "./ckEditor.vue?vue&type=style&index=0&id=6a87b236&lang=css"

const __exports__ = script;

export default __exports__